import { render, staticRenderFns } from "./water-quality-report.vue?vue&type=template&id=5bd5061c&scoped=true"
import script from "./water-quality-report.vue?vue&type=script&lang=js"
export * from "./water-quality-report.vue?vue&type=script&lang=js"
import style0 from "./water-quality-report.vue?vue&type=style&index=0&id=5bd5061c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5061c",
  null
  
)

export default component.exports